/* NightSteel — cookie banner copy hierarchy + layout guard.
   Shopify's admin banner-content field is a single text blob, so the
   approved display line ("Built for a smoother experience.") renders
   swallowed into the body paragraph. This watches for Shopify's
   banner and — ONLY when the exact approved copy is present —
   rebuilds the body into display line / paragraph / control line,
   leaving the policy link node intact. Consent mechanics, buttons
   and the preferences dialog are never touched. If the admin copy
   changes, nothing here matches and the banner renders untouched.
   Approved copy: COOKIE-BANNER.md at the repo root.

   The banner populates its content AFTER inserting the dialog node,
   so enhancement re-attempts from the document root on every
   mutation plus a timed fallback, and stops as soon as it succeeds.

   Also retargets the banner's policy link: Shopify hard-links it to
   /policies/privacy-policy (the near-empty admin policy page) while
   the real policy lives at /pages/privacy-policy. Applies to the
   banner and to the Manage-preferences dialog when it opens. */
(function () {
  var LEAD = 'Built for a smoother experience.';
  var CONTROL_PLAIN = "You're in control.";
  var CONTROL_TYPO = 'You\u2019re in control.';

  var POLICY_FROM = '/policies/privacy-policy';
  var POLICY_TO = '/pages/privacy-policy';

  function fixPolicyLinks(scope) {
    var links = (scope || document).querySelectorAll(
      '#shopify-pc__banner a[href], .shopify-pc__banner__dialog a[href], .shopify-pc__prefs__dialog a[href]'
    );
    for (var i = 0; i < links.length; i++) {
      if (links[i].pathname && links[i].pathname.slice(-POLICY_FROM.length) === POLICY_FROM) {
        links[i].href = POLICY_TO;
      }
    }
  }

  function watchPrefsDialog(dialog) {
    var manage = dialog.querySelector('.shopify-pc__banner__btn-manage-prefs');
    if (!manage) return;
    manage.addEventListener('click', function () {
      setTimeout(fixPolicyLinks, 300);
      setTimeout(fixPolicyLinks, 1000);
    });
  }

  function tryEnhance() {
    var dialog = document.querySelector('.shopify-pc__banner__dialog');
    if (!dialog) return false;
    fixPolicyLinks(dialog);
    if (!dialog.hasAttribute('data-ns-linkwatch')) {
      dialog.setAttribute('data-ns-linkwatch', '');
      watchPrefsDialog(dialog);
    }
    if (dialog.hasAttribute('data-ns-enhanced')) return true;

    var candidates = dialog.querySelectorAll('.shopify-pc__banner__body p, p');
    for (var i = 0; i < candidates.length; i++) {
      var p = candidates[i];
      var text = (p.textContent || '').replace(/\s+/g, ' ').trim();
      if (text.indexOf(LEAD) !== 0) continue;

      var link = p.querySelector('a');
      var linkText = link ? (link.textContent || '').trim() : '';

      var rest = text.slice(LEAD.length).trim();
      if (linkText && rest.slice(-linkText.length) === linkText) {
        rest = rest.slice(0, -linkText.length).trim();
      }

      var control = '';
      var idx = rest.indexOf(CONTROL_TYPO);
      if (idx === -1) idx = rest.indexOf(CONTROL_PLAIN);
      if (idx > -1) {
        control = rest.slice(idx).trim();
        rest = rest.slice(0, idx).trim();
      }

      p.textContent = '';

      var lead = document.createElement('span');
      lead.className = 'ns-consent-lead';
      lead.textContent = LEAD;
      p.appendChild(lead);

      p.appendChild(document.createTextNode(rest));

      if (control) {
        var c = document.createElement('span');
        c.className = 'ns-consent-para';
        c.textContent = control;
        p.appendChild(c);
      }

      if (link) p.appendChild(link);

      dialog.setAttribute('data-ns-enhanced', '');
      return true;
    }
    return false;
  }

  if (tryEnhance()) return;

  var observer = new MutationObserver(function () {
    if (tryEnhance()) {
      observer.disconnect();
      clearInterval(poll);
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  var attempts = 0;
  var poll = setInterval(function () {
    if (tryEnhance() || ++attempts > 25) {
      clearInterval(poll);
      if (attempts > 25) observer.disconnect();
    }
  }, 400);
})();
